import {
  ProcessTimeBucket,
  type ProcessTimeBucket as ProcessTimeBucketType,
} from '../../../api/dto/get-payment-bot-dashboard.dto'

// --- View state ---

export const ALL_CARRIERS = 'all'

// Carrier names whose member rows need UsRestrictedData:Manage. Mirrors EPS
// US_RESTRICTED_CARRIER_NAME_PATTERN ('%kaiser%' ILIKE).
export const US_RESTRICTED_CARRIER_NAME_PATTERN = /kaiser/i

// EPS GLOBAL flag that turns US-restricted enforcement on. Same key EPS reads;
// do not rename.
export const US_RESTRICTED_DATA_ENFORCEMENT_FLAG =
  'service.eps.us-restricted-data.enable-enforcement'

// --- Health palette ---
// Shared by rateColor()/processTimeColor() (helpers) and the dashboard's
// KPI/rate-band rendering so cell colors and filter swatches never drift.
// MUTED is the neutral/placeholder ink.

export const GREEN = '#52c41a'
export const GOLD = '#faad14'
export const RED = '#f5222d'
export const MUTED = '#8c8c8c'

// --- Error codes ---

// Filter sentinel for null-code rows (see GetRecentFailuresRequestDto).
// Normalize null/empty errorCode to 'UNKNOWN' so they can be selected and
// defaulted just like any named code.
export const UNKNOWN_ERROR_CODE = 'UNKNOWN'

// Note column special-cases this code to surface the carrier upstream message.
// Kept as a constant so the literal comparison is never mis-typed.
export const TECHNICAL_ERROR_CODE = 'TECHNICAL_ERROR'

export const ERROR_CODE_LABELS: Record<string, string> = {
  AUTH_FAILED: 'Authentication Failed',
  PAYMENT_CONFLICT: 'Payment Conflict',
  PARTNER_PAYMENT_API_UNREACHABLE: 'API Unreachable',
  PREMIUM_MISMATCH: 'Premium Mismatch',
  AMOUNT_INVALID: 'Invalid Amount',
  METHOD_MISMATCH: 'Payment Method Mismatch',
  BENEFIT_NOT_COVERING_PAYMENT_PERIOD: 'Benefit Coverage Expired',
  TECHNICAL_ERROR: 'Technical Error',
  UNKNOWN: 'Unknown Error',
}

// --- Chart: error breakdown ---
// Fixed row height so a single error code doesn't inflate to fill the whole
// chart (Chart.js stretches category bands when count is low).

export const ERROR_BREAKDOWN_ROW_HEIGHT = 48
export const ERROR_BREAKDOWN_CHART_CHROME = 64
export const ERROR_BREAKDOWN_MAX_BAR_THICKNESS = 32

// --- Process time buckets ---

export const PROCESS_TIME_BUCKET_LABELS: Record<ProcessTimeBucketType, string> =
  {
    [ProcessTimeBucket.UnderOneMin]: '0–1 min',
    [ProcessTimeBucket.OneToTwoMin]: '1–2 min',
    [ProcessTimeBucket.OverTwoMin]: '2 min +',
  }

export const PROCESS_TIME_BUCKET_FILTERS = (
  Object.keys(PROCESS_TIME_BUCKET_LABELS) as ProcessTimeBucketType[]
).map((value) => ({
  text: PROCESS_TIME_BUCKET_LABELS[value],
  value,
}))

// --- Table: column widths ---
// Each table sums its own visible columns' widths (live, from resize state) to
// derive the horizontal scroll width — no precomputed total here.

export const COL_WIDTHS = {
  taskId: 90,
  carrierName: 180,
  benefitId: 160,
  errorCode: 160,
  insuredName: 220,
  failedAt: 160,
  processTimeSec: 130,
  secondAttemptSuccess: 160,
  note: 240,
  logs: 100,
} as const
